export const ArrowSvg = ({ className }: { className?: string }) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="-8 -17.2 434.4 538.6">
		<path d="M55.6 497.4C33.8 508.6 9.1 480.8 1.5 462c-9.5-12.8 28.6-48.3 21.1-43.4 44.9-85.6 67.4-180.8 97.8-272 20.7-84 36.1-118.1 48.3-139.3 14.2-24.5 57 18 73.3 44.4 52.6 85.3 91.5 314.7 134.8 380.8 1 .9 49.6 88.9-14.3 49.6-90-122.3-122.3-329.9-177.1-445.5-13.5-22.6 33.8 14.4 45.9 18-2.5 3.6-8.3 13.7-3.3 5.1-71.9 139.1-79.2 309.7-172.4 437.7z" />
	</svg>
)
